<template lang="html">
  <section class="newsletter" id="newsletter">
    <div class="container">
      <div class="news-text flex row wrap justify-center">
        <h2 class="title title-26">{{ $t("newsletter.titulo") }}</h2>
        <!-- <p>{{ $t("newsletter.texto") }}</p> -->
      </div>

      <form @submit.prevent="validateBeforeSubmit">
        <div class="contenedor-input">
          <input type="text" name="email" v-validate="'required|email'" v-model="email" :placeholder="$t('formulario.introduce_mail')" autocomplete="email" :class="['input-text', { 'has-error': errors.has('email') }]" />
          <span :class="['error', { 'animated shake': clicked }]" v-if="clicked">{{ errors.first("email") }}</span>
        </div>

        <div class="contenedor-check contenedor-input">
          <input id="acepto-comunicaciones" type="checkbox" v-model="aceptoComunicaciones" v-validate="'required'" name="comunicaciones" />
          <label for="acepto-comunicaciones">{{
            $t("formulario.acepto_comunicaciones")
            }}</label>
          <span :class="['error', { 'animated shake': clicked }]" v-if="clicked">{{ errors.first("comunicaciones") }}</span>
        </div>
        <div class="contenedor-check contenedor-input">
          <input id="politica-newsletter" type="checkbox" v-model="politica" v-validate="'required'" name="politica" />
          <label for="politica-newsletter">{{ $t("formulario.he_leido") }}
            <router-link target="_blank" :to="$t('enlaces.politica')">{{
              $t("formulario.y_acepto")
              }}</router-link>.</label>
          <span :class="['error', { 'animated shake': clicked }]" v-if="clicked">{{ errors.first("politica") }}</span>
        </div>

        <button class="btn btn-light -enviar" :clicked="sending" :sendend="sendend" @click="eventGA('button-newsletter-form')">
          <div class="scroller">
            <span>{{ $t("formulario.enviar") }}</span>
<!--             <span>
              <hollow-dots-spinner :animation-duration="1000" :dot-size="15" :dots-num="3" color="#054279" />
            </span> -->
            <!-- <span>{{ $t("formulario.enviado") }}</span> -->
          </div>
        </button>

<!--         <p :class="['sended-confirm', { 'animated fadeInUp': sendend }]">
          {{ $t("newsletter.suscripcion_ok") }}
        </p> -->
      </form>

      <div class="clear"></div>
    </div>
  </section>
</template>

<script lang="js">

  import { HollowDotsSpinner } from 'epic-spinners'

  import { mapGetters } from 'vuex'

  import axios from 'axios'
  import VueAxios from 'vue-axios'


  export default {
    name: 'newsletter',
    props: [],
    mounted() {

    },
    data() {
      return {
        email: '',
        politica: false,
        aceptoComunicaciones: false,
        clicked: false,
        sendend: false,
        loading: false,
        sending: false
      }
    },
    methods: {
      validateBeforeSubmit: function () {
        this.clicked = true;
        this.$validator.validateAll().then(canSend => {
          (canSend) ? this.send() : '';
        });
      },
      send: function () {
        this.loading = true;

        let data = {
          "email": this.email,
          "lang": this.getLanguage
        }

        axios.post('https://dmb.ajusa.online/api/newsletter', data).then(result => {
          this.clicked = false;
          this.sendend = true;
          this.false = true;
          this.email = '';
          this.aceptoComunicaciones = false;
          this.politica = false;
          this.$router.push({ name: "newsletter_thank" });
          this.eventGA('thank-you-page');
        }).catch(error => {
          reject(false);
        });

        // $.ajax({
        //   url: `https://dmb-ajusa.dev.doubledot.es/api/newsletter`,
        //   type: 'POST',
        //   dataType: 'JSON',
        //   data: data,
        // })
        // .done(() =>{
        //   this.clicked = false;
        //   this.sendend = true;
        //   this.false = true;
        // })
        // .fail(() =>{
        //   console.log("error");
        // })
        // .always(() =>{
        //   this.clicked = false;
        //   this.sendend = true;
        //   this.false = true;
        //   this.email = '';
        //   this.aceptoComunicaciones = false;
        //   this.politica = false;
        //   console.log("complete");
        // });

      }
    },
    components: {
      HollowDotsSpinner
    },
    computed: {
      ...mapGetters(['getServer', 'getLanguage', 'getTexts'])
    }
  }
</script>

<style scoped>
  .spring-spinner {
    position: absolute;
    left: 50%;
    top: 50% !important;
    margin-top: -20px;
    margin-left: -20px;
    z-index: 2;
  }

  .newsletter {
    padding-bottom: 0;
  }

  .newsletter>.container {
    padding-bottom: 50px;
    opacity: 1;
  }

  .newsletter .btn {
    min-width: 181px;
    min-height: 57px;
    overflow: hidden;
  }

  .sended-confirm {
    position: absolute;
    width: 100%;
    display: inline-block;
    color: white;
    left: 0;
    bottom: 0px;
    text-align: center;
    opacity: 0;
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus {
    -webkit-text-fill-color: white;
    -webkit-box-shadow: 0 0 0px 1000px #054279 inset;
    background: transparent;
    transition: background-color 5000s ease-in-out 0s;
  }

  .btn.-enviar {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    margin-top: 50px;
    max-width: 270px;
    height: 57px;
    padding: 0;
    outline: none;
    position: relative;
    border-color: #ffed00;
    background: #ffed00;
    color: #054279;
  }

/*   .btn[clicked="true"] .scroller {
    transform: translateY(-33.333333333%);
  }

  .btn[sendend="true"] .scroller {
    transform: translateY(-66.6666666666%);
  } */

  .btn span {
    height: 57px;
    line-height: 57px;
    width: 100%;
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    display: flex;
    justify-content: center;
    -webkit-justify-content: center;
    -ms-align-items: center;
    align-items: center;
    width: 100%;
  }

  .btn span:last-of-type {
    background: #054279;
    color: #fff;
  }
</style>


// WEBPACK FOOTER //
// src/components/parts/newsletter.vue